export default "__VITE_ASSET__98TXsDS8__"